// src/utils/media.js
// One helper for every image/video link on the site.
//
//   mediaSrc("uploads/galleryImg/a.jpg")                     -> http://localhost:5091/uploads/galleryImg/a.jpg   (old files)
//   mediaSrc("https://res.cloudinary.com/x/image/upload/v1/a.jpg")        -> .../image/upload/f_auto,q_auto/v1/a.jpg (Cloudinary)
//   mediaSrc(cloudinaryImageUrl, { w: 800 })                 -> also limits width to 800px (smaller download)
//   posterSrc(cloudinaryVideoUrl)                            -> thumbnail .jpg of the video (frame at 1s)
//
// Works before, during and after the move to Cloudinary, so components never need to know where a file lives.

import { URLS } from "../Url";

const API_BASE = (URLS.Base || "https://api.carnivalcastle.com/").replace(/\/?$/, "/");

// remove transformations we add, so calling mediaSrc twice never stacks them
const OUR_TRANSFORM = /\/upload\/(?:(?:f_auto|q_auto|so_\d+|w_\d+|c_limit)[^/]*)\//;

function withTransform(url, { w } = {}) {
  if (url.includes("/raw/upload/")) return url; // pdf etc.
  const clean = url.replace(OUR_TRANSFORM, "/upload/");
  const isVideo = clean.includes("/video/upload/");
  const t = [isVideo ? "q_auto" : "f_auto,q_auto", w ? `w_${w},c_limit` : null].filter(Boolean).join(",");
  return clean.replace("/upload/", `/upload/${t}/`);
}

/** URL for any stored image/video value (old relative path or full URL). */
export function mediaSrc(value, opts) {
  if (!value) return "";
  const v = String(value).trim().replace(/\\/g, "/");
  if (/^(data:|blob:)/.test(v)) return v;
  if (/^https?:\/\//i.test(v)) {
    return v.includes("res.cloudinary.com/") ? withTransform(v, opts) : v;
  }
  return API_BASE + v.replace(/^\.?\/+/, "");
}

/** Poster image for a Cloudinary video URL ("" for anything else). */
export function posterSrc(videoUrl, w = 800) {
  if (!videoUrl || !videoUrl.includes("res.cloudinary.com/") || !videoUrl.includes("/video/upload/")) return "";
  return videoUrl
    .replace(OUR_TRANSFORM, "/upload/")
    .replace("/upload/", `/upload/so_1,q_auto,w_${w},c_limit/`)
    .replace(/\.[a-z0-9]+(\?.*)?$/i, ".jpg");
}
